import { apiForText } from '.';
import { DATA_ENDPOINT } from '../../config/ap';

const apiData = apiForText.injectEndpoints({
  overrideExisting: true,
  endpoints: build => ({
    getOutputPreview: build.mutation({
      query: ({clientId, data}) => ({
        url: `${DATA_ENDPOINT.PREVIEW}?clientId=${clientId}&transmit=false`,
        method: 'POST',
        body: data
      })
    }),
  })
});

export const {
  useGetOutputPreviewMutation,
} = apiData;